import { type Lang, COPY, renderEm } from "../copy.js";
import { DiscoBall } from "./DiscoBall.js";

export function Hero({ lang }: { lang: Lang }) {
  const t = COPY[lang];
  return (
    <section className="hero">
      <div className="wrap">
        <div className="hero-inner">
          <div className="ball-a">
            <DiscoBall seed={1.3} />
          </div>
          <div className="kicker">{t.hero.kicker}</div>
          <h1 className="cheers">
            {t.hero.cheers[0]}
            <br />
            {t.hero.cheers[1]} <span className="fifty">{t.hero.cheers[2]}</span>
            <br />
            {t.hero.cheers[3]}!
          </h1>
          <p className="subhead subhead-centered">{renderEm(t.hero.sub)}</p>
        </div>
      </div>
    </section>
  );
}
